// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"530":"25bcda03efd80bb9e018","540":"259b8adb800b46c0f700","676":"64a229366b64fd5b2bba","780":"bb9bf584b2e2eac6d81c"}[chunkId] + ".chunk.js";
};